import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { SelectMark } from '@lean-body/components/atoms/select_mark';
import { useNavigate } from 'react-router-dom';
import { routes } from '@lean-body/src/route';
export const PlaylistCard = ({ classObject, imgClassObject, playlist, link, canSelect, onClick, onClickCheckButton, }) => {
    const [isChecked, setIsChecked] = React.useState(false);
    const navigate = useNavigate();
    const onClickHandler = (event) => {
        if (canSelect) {
            onClickCheckButton(event);
            setIsChecked(!isChecked);
        }
        else {
            onClick && onClick(playlist);
        }
        if (link && !canSelect)
            navigate(routes.PLAYLIST.compile({ id: playlist.id.toString() }));
    };
    return (React.createElement("div", { className: css(styles.container, link && styles.isLink, classObject), onClick: onClickHandler, "data-test": "playlistCard" },
        canSelect && React.createElement(SelectMark, { className: css(styles.selectMark), isChecked: isChecked }),
        React.createElement("img", { className: css(styles.img, imgClassObject), src: playlist.thumbnailURL })));
};
const styles = StyleSheet.create({
    container: {
        borderRadius: 10,
        position: 'relative',
    },
    isLink: {
        cursor: 'pointer',
    },
    img: {
        borderRadius: 10,
        width: '100%',
        display: 'block',
    },
    selectMark: {
        position: 'absolute',
        right: 8,
        top: 8,
    },
});
